import { connectedStore } from '../../store';
import selectors from '../selectors';

const getSettings = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getSettings(state);
};

export default getSettings;
